// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// SCAN STAGE INFO SCHEMA
/////////////////////////////////////////

export const ScanStageInfoSchema = z.object({
  name: z.string(),
  status: z.string(),
  startedAt: z.coerce.date().nullable(),
  completedAt: z.coerce.date().nullable(),
  itemsTotal: z.number().int().nullable(),
  itemsDone: z.number().int().nullable(),
  itemsIncomplete: z.number().int().nullable(),
  expectedChunks: z.number().int().nullable(),
  completionPublishedAt: z.coerce.date().nullable(),
  lastProgressAt: z.coerce.date().nullable(),
})

export type ScanStageInfo = z.infer<typeof ScanStageInfoSchema>

export default ScanStageInfoSchema;
